<template>
  <div>
    <header id="header">
      <div
        class="header-content"
        :class="{
          'sso-header-content': rightMenus.indexOf('fromSso') > -1,
          'support-header-content': rightMenus.indexOf('fromSupport') > -1,
        }"
      >
        <div class="header-logo header-actions header-sub-menus">
          <a class="header-cell" @click="sendAnalytics('www')" :href="$link('www')"></a>
        </div>
        <div class="header-navigator">
          <!-- <a class="header-actions" @click="sendEvent('antminer')" :href="$link('antminer')">{{ $trans('蚂蚁矿机') }}</a> -->
          <div
            @mouseenter="showMask"
            @mouseleave="closeMask"
            class="header-miner-actions header-actions actions-menus-big header-sub-menus"
          >
            <div class="item">
              <div class="actions-menus-big-trigger">
                <a @click="sendAnalytics('antminer')" :href="$link('antminer')" class="trigger-inner-link">{{
                  $trans('蚂蚁矿机')
                }}</a>
              </div>
              <transition name="fade" v-if="showSecondMenu">
                <div class="menus-big">
                  <div class="menus-big-inner align-left">
                    <ul class="miner-nav">
                      <li
                        v-for="(item, index) in minerNav.filter((a) => a !== 'Materials' || materials.length > 0)"
                        :key="index"
                        @mouseenter="setProducts(item)"
                        @click="directProduct(item)"
                        :class="[{ on: currentType === item }]"
                      >
                        {{ $trans(item) }}
                        {{ coinAlgorithm[item] && ` | ${coinAlgorithm[item]}` }}
                      </li>
                    </ul>
                    <ul class="miner-products">
                      <template v-if="currentType !== 'Accessories'">
                        <li v-for="item in productList.slice(0, 4)" :key="item.productId">
                          <a
                            @click="sendAnalytics(item.name)"
                            :href="
                              item.sellType === 8
                                ? `${$link('www')}/pizza`
                                : `${$link('antminer')}/product/detail?pid=${item.productId}`
                            "
                          >
                            <div class="name">{{ item.name }}</div>
                            <div class="properties">
                              <span
                                v-if="item.productId !== '00020221016135241904hI9WGE9B0633' && item.hs && item.hs > 0"
                                >{{ item.hs }}{{ item.hsUnit }}</span
                              >
                              <span v-if="item.power">{{ item.power }}</span>
                              <span v-if="item.unitPower"> {{ item.unitPower }}</span>
                            </div>
                            <div class="product-img">
                              <img :src="item.img" :alt="item.name" />
                            </div>
                            <div
                              class="price text-blue"
                              :class="{
                                'sold-out-text': item.productStatus === 4,
                              }"
                            >
                              <template
                                v-if="
                                  (item.productId !== '00020210719174829794879JR3Wp0647' &&
                                    item.productId !== '00020221016135241904hI9WGE9B0633') ||
                                  (item.productId === '00020221016135241904hI9WGE9B0633' && item.price == 500000)
                                "
                              >
                                <template v-if="[1, 2].indexOf(item.productStatus) !== -1">
                                  <span class="status tag" v-if="+item.orderFlag === 1">
                                    {{ $trans('定购') }}
                                  </span>
                                  <span class="status tag" v-if="+item.orderFlag === 2">
                                    {{ $trans('期货') }}
                                  </span>
                                  <span class="status tag" v-if="+item.orderFlag === 3 || +item.preSellFlag === 0">
                                    {{ $trans('现货') }}
                                  </span>
                                </template>
                                <span class="status sold-out" v-if="item.productStatus === 4">
                                  {{ $trans('售罄') }}
                                </span>
                                <span class="time" v-if="item.productStatus === 3">
                                  {{ item.description.split(':')[1] }}
                                </span>
                              </template>
                              <template
                                v-if="item.productId === '00020221016135241904hI9WGE9B0633' && item.price == 500000"
                              >
                                <div v-if="item.priceShowFlag !== '0'">
                                  $1000 + $500000*N (<span class="text-red">deposit</span>)
                                </div>
                              </template>
                              <template v-else>
                                <div v-if="item.priceShowFlag !== '0'">
                                  {{ item.price | currencyPrice(item.currency, '0', 'sell') }}
                                </div>
                              </template>
                            </div>
                          </a>
                        </li>
                      </template>
                      <template v-else>
                        <li v-for="item in parts" :key="item.name">
                          <a
                            @click="sendAnalytics(item.name)"
                            :href="`${$link('antminer')}/product/parts?categoryThree=${item.categoryThree}`"
                          >
                            <div class="name">{{ item.name }}</div>
                            <div class="product-img">
                              <img :src="item.img" :alt="item.name" />
                            </div>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <a @mouseenter="showMask" @mouseleave="closeMask" class="header-actions actions-menus-big header-sub-menus">
            <div class="item">
              <div class="actions-menus-big-trigger" @click="dealMenu('customerSupport', $link('customerSupport'))">
                {{ $trans('服务支持') }}
              </div>
              <transition name="fade" v-if="showSecondMenu">
                <div class="menus-big">
                  <div class="menus-big-inner">
                    <ul v-for="(sub, index) in serviceData" v-bind:key="index" class="ul-item">
                      <li v-for="(item, i) in sub" v-bind:key="i" :class="[{ 'first-child': i === 0 }]">
                        <span v-if="!item.url">{{ item.name }}</span>
                        <template v-else>
                          <a v-if="item.label !== 'materials' || user" @click="dealMenu(item.label, item.url)">
                            <span>{{ item.name }}</span>
                          </a>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </a>
          <a @mouseenter="showMask" @mouseleave="closeMask" class="header-actions header-sub-menus">
            <div class="item">
              <span>{{ $trans('挖矿资源') }}</span>
              <transition name="fade" v-if="showSecondMenu">
                <ul class="header-menus sso-header-menus">
                  <li>
                    <a @click="sendAnalytics('miningFarm')" :href="$link('miningFarm')">
                      <span>{{ $trans('矿场') }}</span>
                    </a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('mining101')" :href="$link('mining101')">
                      <span>{{ $trans('mining101') }}</span>
                    </a>
                  </li>
                  <!-- <li>
                    <a @click="sendAnalytics('PoW')" :href="$link('pow')">
                      <span>{{ $trans("PoW 工作量证明") }}</span>
                    </a>
                  </li> -->
                  <!-- <li>
                    <a @click="sendAnalytics('training')" :href="$link('training')">
                      <span>{{ $trans('培训中心') }}</span>
                    </a>
                  </li> -->
                  <li>
                    <a @click="sendAnalytics('wdms')" :href="$link('wdms')">
                      <span>{{ $trans('WDMS') }}</span>
                    </a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('profitCalculator')" :href="$link('profitCalculator')">
                      <span>{{ $trans('收益计算') }}</span>
                    </a>
                  </li>
                </ul>
              </transition>
            </div>
          </a>
          <a @mouseenter="showMask" @mouseleave="closeMask" class="header-actions header-sub-menus">
            <div class="item">
              <span @click="dealMenu('job', $link('job'))">{{ $trans('招贤纳士') }}</span>
              <transition name="fade" v-if="showSecondMenu">
                <ul class="header-menus sso-header-menus">
                  <li>
                    <a @click="sendAnalytics('job')" :href="$link('students')">
                      <span>{{ $trans('校园招聘') }}</span>
                    </a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('job')" :href="$link('trainee')">
                      <span>{{ $trans('实习生招聘') }}</span>
                    </a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('job')" :href="$link('experienced')">
                      <span>{{ $trans('社会招聘') }}</span>
                    </a>
                  </li>
                </ul>
              </transition>
            </div>
          </a>
          <a class="header-actions header-sub-menus">
            <div class="item">
              <span>{{ $trans('关于我们') }}</span>
              <transition name="fade" v-if="showSecondMenu">
                <ul class="header-menus sso-header-menus">
                  <li>
                    <a @click="sendAnalytics('about')" :href="`${$link('www')}/about`">{{ $trans('关于比特大陆') }}</a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('news')" :href="`${$link('news')}`">{{ $trans('新闻与活动') }}</a>
                  </li>
                  <li>
                    <a @click="sendAnalytics('contactUs')" :href="`${$link('contactUs')}`">{{ $trans('联系我们') }}</a>
                  </li>
                </ul>
              </transition>
            </div>
          </a>
        </div>
        <div class="header-actions">
          <div class="account-actions" ref="accountBox">
            <div
              v-if="myCart"
              class="item cart"
              ref="cart"
              @mouseenter="showDropdown('cart')"
              @mouseleave="hideDropdown"
            >
              <a class="trigger" @click="sendAnalytics('cart')" :href="$link('order')">
                <i class="bt-icon">&#xe616;</i>
                <span>
                  {{ $trans('购物车') }}
                  <em v-if="cartCount">({{ cartCount }})</em>
                </span>
              </a>
            </div>
          </div>
          <div v-if="account" class="account-actions" ref="accountBox">
            <div class="item account">
              <div class="trigger" @click.stop="toggleMenus('user')">
                <img src="./images/account.png" alt="account" class="account-ico" />
              </div>
              <template>
                <transition name="fade" v-if="showSecondMenu">
                  <ul
                    v-if="
                      menus === 'user' && (rightMenus.indexOf('fromKyc') > -1 || rightMenus.indexOf('fromOrder') > -1)
                    "
                    class="menus"
                  >
                    <li>
                      <a :href="$link('mycenter')" @click.stop="toggleMenus('user')">{{ $trans('个人中心') }}</a>
                    </li>
                    <li>
                      <a @click="logout">{{ $trans('退出') }}</a>
                    </li>
                  </ul>
                  <template v-else>
                    <ul v-if="menus === 'user' && !user" class="menus">
                      <li>
                        <a @click="login">{{ $trans('登录') }}</a>
                      </li>
                      <li>
                        <a @click="register">{{ $trans('注册') }}</a>
                      </li>
                    </ul>
                    <ul v-if="menus === 'user' && user" class="menus">
                      <li>
                        <a :href="$link('mycenter')" @click.stop="toggleMenus('user')">{{ $trans('个人中心') }}</a>
                      </li>
                      <li>
                        <a @click="logout">{{ $trans('退出') }}</a>
                      </li>
                    </ul>
                  </template>
                </transition>
              </template>
            </div>
          </div>
          <a
            v-if="bulkOrder"
            @click="sendAnalytics('bulkOrder')"
            :href="$link('hbk')"
            class="account-actions bulkOrder-actions"
          >
            <span class="line"></span>
            <span class="link-bulkOrder">{{ $trans('大宗定购') }}<i></i></span>
            <span class="line"></span>
          </a>
          <div class="item lang">
            <div class="trigger" @click.stop="toggleMenus('lang')">
              <template>
                <img src="./images/global.png" alt="global" />
                <span class="text-sm">{{ locale === 'zh' ? 'CN' : 'EN' }}</span>
              </template>
              <div class="lang-icon"></div>
            </div>
            <transition name="fade" v-if="showSecondMenu">
              <ul v-if="menus === 'lang'" class="header-menus header-locale">
                <li>
                  <a style="text-align: center" @click.stop="changeLocale('zh')">
                    <span>简体中文</span>
                  </a>
                </li>
                <li>
                  <a style="text-align: center" @click.stop="changeLocale('en')">
                    <span>English</span>
                  </a>
                </li>
              </ul>
            </transition>
          </div>
        </div>
        <div v-if="showMenuMask" class="mask-header"></div>
      </div>
      <div class="header-h5">
        <BtCollapse
          :user="user"
          :locale="locale"
          :rightMenus="rightMenus"
          :jumpUrls="jumpUrls"
          :menus="downmenus"
          :login="login"
          :logout="logout"
        />
      </div>
    </header>
  </div>
</template>
<script>
import axios from 'axios';
import BtCollapse from './collapse.vue';
import links from '../links.js';
const i18n = {
  zh: {
    Parts: '配件',
    Materials: '物料',
    mining101: '挖矿科普',
  },
  en: {
    蚂蚁矿机: 'ANTMINER',
    服务支持: 'Customer Support',
    mining101: 'Mining 101',
    'PoW 工作量证明': 'Proof of Work',
    培训中心: 'AMTC',
    矿场资源合作: 'Mining Farm Cooperation',
    挖矿资源: 'Mining Resources',
    全球维修站点: 'Global Repair Sites',
    招贤纳士: 'Careers',
    蚂蚁论坛: 'ANT Forum',
    蚂蚁学院: 'ANT Academy',
    新闻与活动: 'News & Events',
    订单支持: 'Order Support',
    产品支持: 'Product Support',
    售后支持: 'After-Sales Support',
    运费计算器: 'Shipping Calculator',
    序列号查询: 'Track Order SN',
    订单查询: 'Order Tracking',
    下载中心: 'Download Center',
    销售条款: 'Terms of Sale',
    自助寄修: 'Repair Request',
    质保查询: 'Warranty Check',
    服务申请: 'Service Application',
    售后条款: 'After-sales Terms',
    产品手册: 'Product Manual',
    产品使用手册: 'Product User Guide',
    固件下载: 'Firmware Download ',
    语言: 'Language',
    简体中文: 'CN',
    English: 'EN',
    社会招聘: 'Experienced',
    校园招聘: 'Students',
    登录: 'Sign In',
    注册: 'Sign Up',
    个人中心: 'User Center',
    退出: 'Logout',
    大宗定购: 'Bulk Order',
    购物车: 'Cart',
    配件购买: 'Accessories',
    物料购买: 'Materials Purchase',
    产品证书: 'Product Certificate',
    包裹跟踪: 'Track Package',
    售后指南: 'Repair Guide',
    收益计算: 'Profit Calculation',
    矿场: 'Mining Farm',
    关于我们: 'About Us',
    关于比特大陆: 'About BITMAIN',
    比特大陆: 'BITMAIN',
    联系我们: 'Contact Us',
    定购: 'NON-FIXED PRICE',
    期货: 'FUTURES',
    现货: 'SPOT',
    售罄: 'To be continued',
    实习生招聘: 'Internship',
    售后维修点: 'Repair Site',
    '登录/注册': 'Sign In / Sign Up',
    '退出/注册': 'Logout / Sign Up',
    '控制板&排线': 'Control Board&Cable',
    电源: 'Power Supply',
    风扇: 'Fan',
    排线: 'Cable',
    矿场配件: 'Mining Farm Accessories',
  },
};
const prefix = (type) => {
  if (type === 'USD' || type === 'PAYPAL') {
    return '$';
  } else if (type === 'CNY' || type === '元' || type === '人民币转账') {
    return '¥';
  }
  return '';
};

// 后缀
const suffix = (type) => {
  if (type == 'CNY' || type == 'USD' || type == 'PAYPAL' || type === '元' || type === '人民币转账') {
    return '';
  }
  return type;
};
export default {
  components: { BtCollapse },
  props: {
    env: {
      type: String,
      default: 'production',
    },
    locale: {
      type: String,
      default: 'en',
    },
    getRouter: {
      type: Function,
      default: () => null,
    },
    pushRouter: {
      type: Function,
      default: () => false,
    },
    changeLocale: {
      type: Function,
      default: () => {},
    },
    login: {
      type: Function,
      default: () => {},
    },
    logout: {
      type: Function,
      default: () => {},
    },
    register: {
      type: Function,
      default: () => {},
    },
    links: {
      type: Object,
      default: () => ({}),
    },
    mycenterLink: {
      type: String,
      default: '',
    },
    colSource: {
      type: Number,
      default: 0,
    },
    rightMenus: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Boolean,
      default: false,
    },
    cartCount: {
      type: Number,
      default: null,
    },
    hideDropdown: {
      type: Function,
      default: () => {},
    },
    showDropdown: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      top: 0,
      menus: '',
      jumpUrls: [this.$link('www'), this.$link('hbk'), this.$link('ssoLogin')],
      account: this.rightMenus.indexOf('account') > -1,
      bulkOrder: this.rightMenus.indexOf('bulkOrder') > -1,
      myCart: this.rightMenus.indexOf('myCart') > -1,
      showSecondMenu: false,
      downmenus: [],
      serviceData: [],
      minerNav: [
        'BTC/BCH/BSV',
        'ETC',
        'LTC+DOGE',
        'DASH',
        'ZEC/ZEN',
        'KDA',
        'CKB',
        'HNS',
        'KAS',
        'FIL',
        'XMR',
        'ANTSPACE',
        'Accessories',
      ],
      coinAlgorithm: {
        'BTC/BCH/BSV': 'SHA256',
        ETC: 'Ethash',
        'LTC+DOGE': 'Scrypt',
        'ZEC/ZEN': 'Equihash',
        DASH: 'X11',
        DCR: 'Blake256r14',
        KDA: 'Blake2S',
        CKB: 'Eaglesong',
        HNS: 'Blake2B+SHA3',
        KAS: 'kHeavyHash',
        FIL: 'PoST',
        XMR: 'RandomX',
      },
      showMenuMask: false,
      allProducts: [],
      productList: [],
      currentType: 'BTC/BCH/BSV',
      parts: [],
      materials: [],
      isMobile: false,
    };
  },
  filters: {
    // 金额格式化
    // unit 小数
    // type 币种
    currencyPrice: function (num, unit, type, mode) {
      num = Number(num);
      if (isNaN(num)) {
        return 'NaN';
      }
      if (unit !== undefined && typeof unit !== 'number') {
        type = unit;
        unit = undefined;
      }
      // 支付币种
      type = type || (site === 'cn' ? 'CNY' : 'USD');

      // 保留小数
      if (type == 'CNY' || type == 'USD' || type == 'PAYPAL' || type === '元' || type === '人民币转账') {
        num = num.toFixed(typeof unit === 'number' ? unit : 2);
      } else {
        num = num.toFixed(typeof unit === 'number' ? unit : 8);
      }
      //显示方式，当为售价的显示显示为千分符
      if (mode === 'sell') {
        num = parseFloat(num).toLocaleString();
      } else {
        num = num;
      }
      // 后缀加间隔
      let text = prefix(type) + num;
      if (suffix(type)) {
        text += ' ' + suffix(type);
      }
      return text;
    },
  },
  computed: {
    hProductList() {
      const list = [];
      this.minerNav.forEach((item, index) => {
        if (item === 'Accessories') {
          list.push({
            index: index,
            name: item,
            url: `${this.$link('hBuyingParts')}`,
            label: item,
          });
        } else {
          list.push({
            index: index,
            name: item,
            url: `${this.$link('hAntminer')}?coin=${encodeURIComponent(item)}`,
            label: item,
          });
        }
      });
      return list;
    },
  },
  created() {
    axios.defaults.timeout = 20000;
    axios.defaults.withCredentials = true;
    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    // this.addAccount();
  },
  mounted() {
    this.isMobile = document.body.clientWidth <= 768;
    // 自动关闭菜单
    document.addEventListener('click', this.closeMenus);
    this.showSecondMenu = true;
    this.serviceData = this.reloadServiceData();
    this.downmenus = this.reloadDownmenus();
    this.addAccount();
    if (!this.isMobile) {
      this.getProducts();
    }
    this.getParts();
    // this.getMaterials();
  },
  destroyed() {
    document.removeEventListener('click', this.closeMenus);
  },
  watch: {
    locale() {
      this.serviceData = this.reloadServiceData();
      this.downmenus = this.reloadDownmenus();
      this.addAccount();
    },
    user() {
      this.serviceData = this.reloadServiceData();
      this.downmenus = this.reloadDownmenus();
      this.addAccount();
      // this.getMaterials();
    },
  },
  methods: {
    $trans(key) {
      let messages = i18n[this.locale];

      if (!messages) {
        messages = i18n.en;
      }

      return messages[key] || key;
    },
    $link(type) {
      const router = this.getRouter(type);
      if (router) {
        return router;
      }
      const language = this.locale === 'zh' ? 'zh' : 'en';
      const key = this.env === 'production' ? language : `${language}Beta`;
      if (type === 'mycenter') {
        return this.mycenterLink ? this.mycenterLink : links[key][type] || '';
      }
      return links[key][type] || '';
    },
    $pushRouter(type) {
      if (!this.pushRouter(type)) {
        location.href = this.$link(type);
      }
    },
    dealMenu(label, url) {
      window.location.href = url;
      this.sendAnalytics(label);
    },
    directProduct(item) {
      this.sendAnalytics(item);
      if (item === 'Accessories') {
        window.location.href = this.$link('buyingParts');
      } else if (item === 'Materials') {
        window.location.href = this.$link('buyingMaterials');
      } else {
        window.location.href = `${this.$link('antminer')}?coin=${encodeURIComponent(item)}`;
      }
    },
    getProducts() {
      const url = `${this.$link('shopService')}/api/productshow/getMainProduct`;
      axios.get(url).then(({ data, code }) => {
        const res = `${code}` === '0' ? { data, code: '0' } : data;
        if (res && res.code === '0') {
          this.allProducts = res.data || [];
          this.allProducts.forEach((a) => {
            if (a.productId === '00020221016135241904hI9WGE9B0633') {
              a.miningCurrency = 'BTC,BCH,BSV';
            }
            a.miningCurrency = a.miningCurrency.replace(/,/g, '/');
            a.type = 'miner';
          });
          this.setProducts(this.currentType);
        }
      });
    },
    getParts() {
      this.parts = [
        {
          type: 'part',
          categoryThree: 10102,
          name: this.$trans('控制板&排线'),
          img: 'https://file.bitmain.com/shop-image-storage/product/2023/12/29/18/0b242652-205d-4b47-8905-60907c338eaf.jpg',
        },
        {
          type: 'part',
          categoryThree: 10170,
          name: this.$trans('电源'),
          img: 'https://file.bitmain.com/shop-image-storage/product/2024/01/24/17/bab6b731-a9e7-48b6-ad23-7dd83ef5c49a.png',
        },
        {
          type: 'part',
          categoryThree: 10171,
          name: this.$trans('风扇'),
          img: 'https://file.bitmain.com/shop-image-storage/product/2024/02/06/10/ee39e685-4eab-4883-b3df-6ee032fdfead.png',
        },
        // {
        //   type: 'part',
        //   categoryThree: 10172,
        //   name: this.$trans('排线'),
        //   img: 'https://file.bitmain.com/shop-image-storage/product/2018/10/08/16/ea0eb922-17ea-4117-8ad6-d3582a02b9fb.jpg',
        // },
        {
          type: 'part',
          categoryThree: 10257,
          name: this.$trans('矿场配件'),
          img: 'https://file.bitmain.com/shop-image-storage/product/2024/02/21/18/64387aca-5a94-49c2-b360-e02ac8098763.png',
        },
      ];
      // const url = `${this.$link("shopService")}/api/part/getPartsCategory`;
      // axios.get(url).then(({ data, code }) => {
      //   const res = `${code}` === "0" ? { data, code: "0" } : data;
      //   if (res && res.code === "0") {
      //     const categories = res.data || [];
      //     categories.forEach((a) => {
      //       const arr = a.partVOList
      //         ? a.partVOList.map((b) => ({
      //             ...b,
      //             categoryName: a.categoryName,
      //             type: "part",
      //           }))
      //         : [];
      //       this.parts = this.parts.concat(arr);
      //     });
      //   }
      // });
    },
    getMaterials() {
      if (this.user || this.rightMenus.indexOf('fromKyc') > -1 || this.rightMenus.indexOf('fromOrder') > -1) {
        const url = `${this.$link('shopService')}/api/material/getMaterialsCategory`;
        axios.get(url, { force: false }).then(({ data, code }) => {
          const res = `${code}` === '0' ? { data, code: '0' } : data;
          if (res && res.code === '0') {
            const categories = res.data || [];
            categories.forEach((a) => {
              const arr = a.materialVOList
                ? a.materialVOList.map((b) => ({ ...b, categoryName: a.categoryName, type: 'material' }))
                : [];
              this.materials = this.materials.concat(arr);
            });
          }
        });
      }
    },
    setProducts(type) {
      this.currentType = type;
      if (type === 'Accessories') {
        this.productList = this.parts;
      } else if (type === 'Materials') {
        this.productList = this.materials;
      } else if (type === 'ANTSPACE') {
        this.productList = this.allProducts.filter((a) => a.categoryThree === 10101 || a.categoryThree === 10256);
      } else {
        this.productList = this.allProducts.filter(
          (a) => a.categoryThree !== 10101 && a.categoryThree !== 10256 && a.miningCurrency === this.currentType
        );
      }
    },
    addAccount() {
      if (this.account) {
        let accoutMenu =
          this.user || this.rightMenus.indexOf('fromKyc') > -1
            ? {
                index: 7,
                name: this.$trans('退出'),
                onClick: () => {
                  this.logout();
                },
                label: 'logout',
              }
            : {
                index: 7,
                name: this.$trans('登录/注册'),
                children: [
                  {
                    index: 0,
                    name: this.$trans('登录'),
                    onClick: () => {
                      this.login();
                    },
                  },
                  {
                    index: 1,
                    name: this.$trans('注册'),
                    onClick: () => {
                      this.register();
                    },
                  },
                ],
              };
        this.downmenus.push(accoutMenu);
      }
    },
    reloadServiceData() {
      return [
        [
          { name: this.$trans('产品支持') },
          {
            name: this.$trans('产品手册'),
            url: this.$link('manual'),
            label: 'manual',
          },
          // { name: this.$trans('产品使用手册'), url: this.$link('userGuide'), label: 'userGuide' },
          {
            name: this.$trans('固件下载'),
            url: this.$link('firewareDownload'),
            label: 'firewareDownload',
          },
          {
            name: this.$trans('配件购买'),
            url: this.$link('buyingParts'),
            label: 'accessories',
          },
          {
            name: this.$trans('物料购买'),
            url: this.$link('buyingMaterials'),
            label: 'materials',
          },
          {
            name: this.$trans('产品证书'),
            url: this.$link('productCertificate'),
            label: 'certificate',
          },
        ],
        [
          { name: this.$trans('订单支持') },
          {
            name: this.$trans('运费计算器'),
            url: this.$link('calc'),
            label: 'calc',
          },
          {
            name: this.$trans('序列号查询'),
            url: this.$link('orderSn'),
            label: 'orderSn',
          },
          {
            name: this.$trans('订单查询'),
            url: this.$link('orderState'),
            label: 'orderState',
          },
          {
            name: this.$trans('销售条款'),
            url: this.$link('saleTerms'),
            label: 'saleTerms',
          },
          {
            name: this.$trans('包裹跟踪'),
            url: this.$link('packageTracking'),
            label: 'tracking',
          },
        ],
        [
          { name: this.$trans('售后支持') },
          {
            name: this.$trans('自助寄修'),
            url: this.$link('sendRepair'),
            label: 'sendRepair',
          },
          {
            name: this.$trans('质保查询'),
            url: this.$link('warranty'),
            label: 'warranty',
          },
          {
            name: this.$trans('服务申请'),
            url: this.$link('apply'),
            label: 'apply',
          },
          {
            name: this.$trans('售后条款'),
            url: this.$link('supportTerms'),
            label: 'supportTerms',
          },
          {
            name: this.$trans('售后维修点'),
            url: this.$link('repairSite'),
            label: 'repairSite',
          },
          // { name: this.$trans('售后指南'), url: this.$link('repairGuide'), label: 'guide' },
        ],
        [
          { name: this.$trans('蚂蚁学院') },
          { name: this.$trans('蚂蚁论坛'), url: this.$link('ANTforum'), label: 'ANTforum' },
        ],
      ];
    },
    reloadDownmenus() {
      return [
        {
          index: 0,
          name: this.$trans('蚂蚁矿机'),
          children: this.hProductList,
        },
        {
          index: 1,
          name: this.$trans('服务支持'),
          url: this.$link('hcustomerSupport'),
          label: 'support',
        },
        {
          index: 2,
          name: this.$trans('挖矿资源'),
          children: [
            // {
            //   index: 0,
            //   name: this.$trans('矿场资源合作'),
            //   url: this.$link('dataCenterCooperation'),
            //   label: 'dataCenterCooperation',
            // },
            {
              index: 0,
              name: this.$trans('矿场'),
              url: this.$link('miningFarm'),
              label: 'miningFarm',
            },
            {
              index: 1,
              name: this.$trans('mining101'),
              url: this.$link('mining101'),
              label: 'mining101',
            },
            // {
            //   index: 3,
            //   name: this.$trans('PoW 工作量证明'),
            //   url: this.$link('pow'),
            //   label: 'pow',
            // },
            // {
            //   index: 4,
            //   name: this.$trans('培训中心'),
            //   url: this.$link('training'),
            //   label: 'training',
            // },
            {
              index: 2,
              name: this.$trans('WDMS'),
              url: this.$link('wdms'),
              label: 'wdms',
            },
          ],
        },
        // <a @click="sendAnalytics('about')" :href="`${$link('www')}/about`">{{ $trans('关于我们') }}</a>
        {
          index: 3,
          name: this.$trans('招贤纳士'),
          children: [
            // trainee: 'https://jobs.bitmain.com/trainee',
            {
              index: 0,
              name: this.$trans('校园招聘'),
              url: this.$link('students'),
              label: 'job',
            },
            {
              index: 1,
              name: this.$trans('实习生招聘'),
              url: this.$link('trainee'),
              label: 'job',
            },
            {
              index: 2,
              name: this.$trans('社会招聘'),
              url: this.$link('experienced'),
              label: 'job',
            },
          ],
        },
        {
          index: 4,
          name: this.$trans('关于我们'),
          children: [
            {
              index: 0,
              name: this.$trans('关于比特大陆'),
              url: `${this.$link('www')}/about`,
              label: 'about',
            },
            {
              index: 1,
              name: this.$trans('新闻与活动'),
              url: `${this.$link('www')}/news`,
              label: 'news',
            },
            {
              index: 2,
              name: this.$trans('联系我们'),
              url: `${this.$link('contactUs')}`,
              label: 'contactUs',
            },
          ],
        },
        // {
        //   index: 5,
        //   name: this.$trans('蚂蚁论坛'),
        //   url: this.$link('ANTforum'),
        //   label: 'ANTforum',
        // },
        {
          index: 5,
          name: this.$trans('个人中心'),
          url: this.$link('hMycenter'),
          label: 'user',
        },
        {
          index: 6,
          name: this.$trans('语言'),
          children: [
            {
              index: 0,
              name: '简体中文',
              onClick: () => {
                this.changeLocale('zh');
              },
            },
            {
              index: 1,
              name: 'English',
              onClick: () => {
                this.changeLocale('en');
              },
            },
          ],
        },
      ];
    },
    sendAnalytics(name) {
      const sendEvent = this.sendEvent || window.sendEvent;
      if (sendEvent) {
        const label = i18n.en[name] || name;
        sendEvent('头部', `bitmain-header-${label}`);
      }
    },
    goBlock(id) {
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    },
    // 开关菜单
    toggleMenus(type) {
      this.menus = this.menus === type ? null : type;
      this.showMenuMask = !!this.menus;
    },
    closeMenus() {
      this.menus = null;
      this.showMenuMask = false;
    },
    showMask() {
      if (this.maskTimer) {
        clearTimeout(this.maskTimer);
      }
      this.menus = null;
      this.showMenuMask = true;
    },
    closeMask() {
      if (this.maskTimer) {
        clearTimeout(this.maskTimer);
      }
      this.maskTimer = setTimeout(() => (this.showMenuMask = false), 200);
    },
  },
};
</script>
<style lang="less" scoped>
@blue: #3581ff;
#header {
  font-family: 'Arial', 'Red Hat Text', 'lucida grande', 'lucida sans unicode', lucida, helvetica, 'Hiragino Sans GB',
    'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  .text-red {
    color: red;
  }
  .mask-header {
    position: fixed;
    top: 86px;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.4;
    z-index: 10;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
    border: none;
  }
  a {
    margin: 0;
    padding: 0;
  }
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 86px;
  transition: all 1s;
  background-color: #ffffff;
  color: #000000;
  border-bottom: 1px solid #e3e3e3;
  .header-sub-menus {
    .mask-menu {
      position: fixed;
      top: 86px;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.4;
      z-index: 1;
      display: none;
      &:hover {
        display: none !important;
      }
    }
    .header-menus,
    .menus-big {
      display: none;
    }
    &:hover {
      .mask-menu,
      .header-menus,
      .menus-big {
        display: block;
      }
    }
  }
  // LOGO
  .header-logo {
    position: relative;
    float: left;
    padding-right: 80px;
    height: 86px;
    @media (max-width: 1350px) {
      padding-right: 10px;
    }
    .header-cell {
      width: 140px;
      height: 17px;
      display: inline-block;
      background: url(./images/logo-black.png) no-repeat center center;
      background-size: contain;
    }
    .text {
      display: inline-block;
      width: 50px;
      height: 20px;
      background-color: #fff;
      margin-left: 15px;
      color: #666;
      font-size: 14px;
      line-height: 20px;
      border-radius: 2px;
      z-index: 2;
    }
  }
  .header-content {
    max-width: 1400px;
    padding: 0 10px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // 导航
    .header-navigator {
      flex: 1;
      text-align: left;
      padding-left: 15px;
      .header-miner-actions,
      a {
        position: relative;
        color: unset;
        padding: 30px;
        font-size: 16px;
        display: inline-block;
        &::before {
          position: absolute;
          top: 3px;
          left: 49%;
          width: calc(100% - 39px);
          height: 3px;
          background-color: #181a21;
          transition: all 1s;
          transform: translate(-50%);
          opacity: 0;
          content: '';
        }
        &:hover {
          cursor: pointer;
          &::before {
            opacity: 1;
          }
        }
        &.header-actions {
          padding: 34px 30px;
          a:hover::before {
            opacity: 0;
          }
          @media (max-width: 1350px) {
            padding: 34px 15px;
            font-size: 16px;
          }
          @media (max-width: 1200px) {
            padding: 34px 10px;
            font-size: 14px;
          }
          @media (max-width: 1040px) {
            padding: 34px 8px;
          }
        }
        &.trigger-inner-link {
          padding: 0;
        }
        @media (max-width: 992px) {
          padding: 30px 10px 30px;
        }
        @media (max-width: 820px) {
          padding: 30px 6px 30px;
        }
      }
      .header-actions {
        .header-menus {
          top: 55px;
          li {
            a {
              font-size: 14px;
            }
          }
        }
      }
    }

    .menus-big {
      position: fixed;
      top: 85px;
      left: 0;
      padding-left: 15px;
      background: #ffffff;
      width: 100%;
      text-align: left;
      line-height: 50px;
      padding: 0 10px;
      font-size: 14px;
      border-top: 1px solid #e3e3e3;
      border-bottom: 1px solid #e3e3e3;
      //box-shadow: 0 2px 5px 0 rgba(40, 40, 40, 0.2);
      border-radius: 0;
      background: #fdfdfd;
      color: rgba(0, 0, 0, 0.6);
      padding: 40px 0;
      z-index: 11;
      // cursor: default;
      .menus-big-inner {
        max-width: 1400px;
        padding: 0 10px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        &.align-left {
          justify-content: flex-start;
        }
      }

      ul li.first-child {
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
        color: #000;
        //border-bottom: 1px solid rgba(40, 40, 40, 0.4);
        margin-bottom: 20px;
        word-break: keep-all;
        white-space: nowrap;
        cursor: default;
      }
      .actions-menus-big-trigger {
        position: relative;
      }
      .ul-item {
        display: inline-block;
        vertical-align: top;
        text-align: left;
        border-right: 1px solid #e3e3e3;
        margin: 0 3.4% 0 0;
        padding-right: 10%; //170px
        &:last-child {
          border: 0;
          margin: 0;
          padding: 0;
        }
      }
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 3.6% 0 0;
        line-height: 40px;
        a {
          text-align: left;
          padding: 0;
          font-size: 14px;
          white-space: nowrap;

          &:hover {
            text-decoration: underline;
            &:before {
              display: none;
            }
          }
        }
      }
    }
    .header-actions {
      display: flex;
      align-items: center;
      user-select: none;
      & > .item {
        position: relative;
        & + .item {
          margin-left: 10px;
        }
      }
      .account-actions {
        display: flex;
        align-items: center;
        user-select: none;
        height: 100%;
        @media (max-width: 768px) {
          display: none;
        }
        & > .item {
          position: relative;
          & + .item {
            margin-left: 10px;
          }
        }

        .menus {
          position: absolute;
          top: 63px;
          left: -42px;
          z-index: 999;
          list-style: none;
          width: 190px;
          line-height: 50px;
          padding: 0 10px;
          font-size: 14px;
          // order报错
          // box-shadow: 0px 2px 10px 0 rgba(40, 40, 40, 0.1);
          border: 1px solid #e3e3e3;
          border-radius: 0 0 4px 4px;
          background: #ffffff;
          border-top: none;
          color: #262626;
          li {
            &:not(:last-child) {
              border-bottom: 1px solid #eee;
            }
            a {
              display: block;
              text-align: center;
              cursor: pointer;
              color: #262626;
              &:hover {
                text-decoration: underline;
              }
            }
          }

          &:before {
            display: none;
            content: ' ';
            position: absolute;
            top: -4px;
            left: 80px;
            width: 10px;
            height: 10px;
            border-radius: 2px;
            background: #fff;
            transform: rotate(45deg);
          }
        }
        .cart {
          .trigger {
            display: flex;
            align-items: center;
            min-width: 70px;
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 12px;
            // background-color: #3581ff;
            border-radius: 2px;
            cursor: pointer;
            // transition: background-color 0.1s;
            .bt-icon {
              font-size: 22px;
              color: #666;
            }
            span {
              font-size: 16px;
              margin-left: 3px;
              color: #1c1c1c;
              em {
                font-style: normal;
              }
            }
          }

          .glance {
            position: absolute;
            top: 55px;
            right: -40px;
            z-index: 999;
            font-size: 14px;
            width: 300px;
            line-height: 1.5;
            color: #262626;
            .blank {
              padding: 30px 20px;
              line-height: 2;
              .bt-icon {
                font-size: 40px;
                line-height: 1;
              }
            }
            .aux {
              position: relative;
              margin-top: 10px;
              background: #fdfdfd;
              border-radius: 4px;
              box-shadow: 0 0 3px 0 hsla(0, 0%, 77%, 0.5);

              &:before {
                content: ' ';
                position: absolute;
                top: -4px;
                left: 200px;
                width: 10px;
                height: 10px;
                border-radius: 2px;
                background: #fff;
                transform: rotate(45deg);
              }
              ul {
                overflow: auto;
                max-height: 202px;
                list-style: none;
                li {
                  position: relative;
                  border-bottom: 1px solid #eee;
                  .delete {
                    position: absolute;
                    right: 15px;
                    top: 30px;
                    display: none;
                    cursor: pointer;
                  }
                  &:hover .delete {
                    display: block;
                  }
                  a {
                    display: block;
                    text-align: left;
                    color: #262626;
                    padding: 10px 0;
                    .avatar {
                      float: left;
                      width: 80px;
                      height: 80px;
                      padding: 10px;
                      display: flex;
                      align-items: center;
                      overflow: hidden;
                      img {
                        display: block;
                        margin: auto;
                        max-height: 60px;
                      }
                    }
                    .text {
                      font-size: 14px;
                      height: 80px;
                      margin-left: 100px;
                      padding: 20px 20px 0 0;
                      h4 {
                        font-weight: normal;
                      }
                      .price {
                        color: @blue;
                      }
                    }
                  }
                }
              }

              .summary {
                padding: 15px;
              }
            }
          }
        }
        .lang {
          position: relative;
          padding-left: 10px;
          line-height: 1;
          .trigger {
            display: flex;
            align-items: center;
            padding: 8px 10px;
            line-height: 24px;
            border-radius: 2px;
            cursor: pointer;
            color: unset;
            img {
              width: 18px;
              height: 17px;
              margin-right: 6px;
              @media (max-width: 992px) {
                display: none;
              }
            }
            .bt-icon {
              font-size: 14px;
              transform: scale(0.8);
            }
          }
          .menus {
            img {
              width: 26px;
              height: 17px;
              margin-right: 3px;
              margin-top: -2px;
              vertical-align: middle;
            }
            span {
              display: inline-block;
              min-width: 4em;
              text-align: left;
            }
            a {
              &:hover {
                span {
                  text-decoration: underline;
                }
              }
            }
          }
        }
        .account {
          .menus {
            left: -70px;
            top: 53px;
          }
          .account-ico {
            cursor: pointer;
            width: 17px;
            vertical-align: middle;
            //filter: url('#test');
          }
        }
      }
      .bulkOrder-actions {
        margin-right: -18px;
        .line {
          display: inline-block;
          height: 19px;
          width: 1px;
          background: #bfc0c3;
          margin: 0 10px;
        }
        .link-bulkOrder {
          font-size: 16px;
          color: #1c1c1c;
          i {
            display: none;
          }
        }
      }
      .header-menus {
        position: absolute;
        top: 63px;
        left: -15px;
        z-index: 999;
        list-style: none;
        width: 190px;
        line-height: 50px;
        padding: 0 10px 0 15px;
        font-size: 14px;
        // order报错
        // box-shadow: 0px 2px 10px 0 rgba(40 40 40 / 10%);
        border-radius: 0 0 4px 4px;
        background: #ffffff;
        color: #262626;
        border: 1px solid #e3e3e3;
        border-top: 0;
        li {
          &:not(:last-child) {
            border-bottom: 1px solid #eee;
          }
          a {
            display: block;
            text-align: left;
            cursor: pointer;
            color: #262626;
            padding: 0;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        &.header-menus-logo {
          top: 86px;
          left: -15px;
          padding-left: 15px;
          li a {
            text-align: left;
          }
        }
      }
      .header-locale {
        left: -82px;
      }
      .lang {
        position: relative;
        padding-left: 10px;
        line-height: 1;
        .lang-icon {
          width: 0;
          height: 0;
          border-right: 5px solid transparent;
          border-left: 5px solid transparent;
          border-top: 5px solid #000000;
          margin-left: 3px;
        }
        .trigger {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          line-height: 24px;
          cursor: pointer;
          color: unset;
          img {
            width: 18px;
            //height: 24px;
            margin-right: 6px;
            @media (max-width: 992px) {
              display: none;
            }
          }
          .bt-icon {
            font-size: 12px;
            transform: scale(0.8);
          }
        }
        .header-menus {
          img {
            width: 24px;
            height: 24px;
            margin-right: 3px;
            margin-top: -2px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            min-width: 4em;
            text-align: left;
          }
          li {
            span {
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
      .text-sm {
        font-size: 16px;
      }
    }
    .lang-box {
      position: relative;
      margin: 0 0 0 15px;
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      padding-left: 15px;
      .ivu-btn-primary {
        border-color: rgba(255, 255, 255, 0.5);
        background: transparent;
        height: initial;
        padding: 0 5px;
        font-size: 12px;
      }
      .ivu-btn {
        font-weight: 600;
        &:hover {
          color: #000000;
          background-color: #fff;
          border-color: #000000;
        }
      }
      .ivu-select-dropdown {
        padding: 0;
        background: #ffffff;
        border: 1px solid #ffffff;
        box-shadow: 1px 1px 6px 0 hsla(0, 0%, 77%, 0.5);
        border-radius: 0px 0px 7px 7px;
        border-top: none;
        top: 44px !important;
        .ivu-dropdown-item {
          padding: 12px 16px;
          border-bottom: none;
          color: #000000;
          min-width: 140px;
          font-size: 14px !important;
          &:before {
            display: none;
            content: '';
            position: absolute;
            top: -9px;
            left: 50%;
            margin-left: -6px;
            border-bottom: 9px solid #fff;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: none;
            opacity: 0.5;
          }
          &.active {
            color: #32a6ff;
          }
          &:hover {
            background: #ffffff;
          }
        }
      }
    }
  }
  .navbar.navbar-default.portal .navbar-nav > li .caret {
    color: hsla(0, 0, 0, 0.3);
    margin-top: 0px;
  }

  .navbar.navbar-default.portal .navbar-nav > li:hover .caret,
  .navbar.navbar-default.portal .navbar-nav > li.open .caret {
    color: #000000;
  }
  &.opened {
    background-color: #000000 !important;
  }
  .header-h5 {
    display: none;
  }
  .miner-nav {
    width: 14%;
    min-width: 172px;
    li {
      position: relative;
      &:after {
        display: inline-block;
        content: '';
        width: 7px;
        height: 12px;
        background: url(./images/nav-default.png) no-repeat center center;
        background-size: contain;
        position: absolute;
        right: 0;
        top: 14px;
      }
      &:hover,
      &.on {
        color: #3471ff;
        &:after {
          background: url(./images/nav-on.png) no-repeat center center;
          background-size: contain;
        }
      }
    }
  }
  .miner-products {
    width: 85%;
    display: flex;
    align-items: center;
    padding: 12px 0;
    li {
      width: 25%;
      // height: max-content;
      // display: flex;
      // flex-direction: column;
      // justify-content: flex-start;
      // align-items: center;
      border-left: 1px solid #e3e3e3;
      padding: 0 !important;
      height: 100%;
      text-align: center;
      &:first-child {
        border-left: none;
      }
      a {
        padding: 0 30px;
        text-align: center !important;
        max-width: 80%;
        overflow: hidden;
        &:hover {
          text-decoration: unset !important;
        }
      }
    }
    .product-img {
      //width: 45%;
      width: 130px;
      height: 115px;
      margin: 22px auto 0;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .name {
      font-size: 14px;
      color: #000000;
      line-height: 1;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .properties {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      min-height: 12px;
      font-size: 12px;
      color: #000;
      margin: 12px auto 6px;
      span {
        display: inline-block;
        vertical-align: middle;
        border-left: 1px solid #000;
        padding: 0 8px;
        line-height: 12px;
        &:first-child {
          border-left: none;
        }
      }
    }
    .status {
      display: block;
      color: #fff;
      font-size: 12px;
      padding: 4px 3px 2px 5px;
      border-radius: 0px 7px 0px 7px;
      margin: 0 6px 3px 0;
      text-align: center;
      line-height: 12px;
      white-space: nowrap;
      &.tag {
        background: #ce332d;
      }
      &.pre {
        background: #60a31f;
      }
      &.futures {
        background: #eca316;
      }
      &.spot {
        background: #4273f6;
      }
      &.sold-out {
        background: #727272;
      }
      &.coming-soon {
        background: #ef5252;
      }
    }
    .time {
      color: #000;
      font-size: 14px;
      margin-right: 15px;
    }
    .price {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #4273f6;
      margin-top: 10px;
    }
  }
}
.sso-header-content {
  .sso-header-menus {
    top: 52px !important;
  }
}
@media (max-width: 960px) {
  #header {
    height: 50px;
    .header-content {
      display: none;
    }
    .header-h5 {
      display: block;
    }
    .header-logo {
      padding: 17px 20px;
    }
  }
}
</style>
